export default "__VITE_ASSET__ZfULvq1l__"